<template>
  <a-modal :title="`【${user.name}】的心愿值`"
           :width="600"
           :open="modal"
           @cancel="cancelCk">
    <a-space class="nav-no-title">
      <div>当前心愿值
        <a-tag :bordered="false" color="green">{{ current }}</a-tag>
      </div>
      <a-select :options="itemList"
                v-model:value="itemId"
                size="small"
                @change="query"/>
      <a-button size="small" type="primary" @click="addCk">调整心愿值</a-button>
    </a-space>

    <a-table size="small"
             :columns="columns"
             :data-source="source"
             :loading="loading"
             :pagination="pagination"
             :onChange="handlePage">
      <template v-slot:bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'num'">
          <a-space>
            <a-tag :bordered="false" :color="record.num > 0 ? 'green' : 'red'">{{ record.num }}</a-tag>
          </a-space>
        </template>

        <template v-else>
          {{ record[column.dataIndex] }}
        </template>
      </template>
    </a-table>

    <template #footer></template>
  </a-modal>

  <add-point-modal ref="addPoint" @refresh="query"/>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'

import AddPointModal from '@/views/user/AddDrawPoint.vue'

const itemId = ref(0)
const current = ref(0)

const source = ref([])

const user = ref({})

const modal = ref(false)
const loading = ref(false)

const addPoint = ref(null)

const pagination = ref({
  showSizeChanger: true,
  defaultCurrent: 1,
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  total: 0,
  onShowSizeChange: (current, size) => {
    pagination.value.current = 1
    pagination.value.pageSize = size
    query()
  }
})

const columns = [
  {
    key: 'id',
    title: 'ID',
    dataIndex: 'id',
  }, {
    key: 'num',
    title: '数值',
    dataIndex: 'num',
  }, {
    key: 'createTime',
    title: '时间',
    dataIndex: 'createTime',
  },
]

let itemList = []

function query() {
  loading.value = true

  axios.get(`/user/${user.value.id}/draw-point/${itemId.value}`, {
    params: {
      page: pagination.value.current,
      size: pagination.value.pageSize,
    }
  }).then((res) => {
    loading.value = false

    if (res.code === 1) {
      pagination.value.current = res.data.page
      pagination.value.total = res.data.total
      source.value = res.data.data
      current.value = res.data.current
    }

    modal.value = true
  })
}

function handlePage(param) {
  pagination.value.current = param.current
  pagination.value.pageSize = param.pageSize
  query()
}

function item() {
  axios.get('/order/export-item', {
    params: {
      draw: 1
    }
  }).then((res) => {
    if (res.code === 1) {
      itemList = res.data
      if (itemList.length) {
        itemId.value = itemList[0].value
      }
      query()
    }
  })
}

function openCk(record) {
  user.value = record
  item()
}

function addCk() {
  addPoint.value.openCk(user.value.id, itemId.value)
}

function cancelCk() {
  modal.value = false
}

defineExpose({openCk})
</script>